import {FC} from "react";
import {Button} from "../../ui-components/button.tsx";

type LightButtonType = {
    title: string
    onClick: () => void
}

export const LightButton: FC<LightButtonType> = ({title, onClick}) => {
    return (
        <Button
            color={"white"}
            onClick={onClick}
            className="w-full !bg-white !text-sm !font-semibold !py-[10px] rounded-lg !border !border-[var(--btn-border-custom)] shadow-xs"
        >
            {title}
        </Button>
    )
}